if (!customElements.get('dd-collection-navigation')) {
  customElements.define('dd-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const bar = this.querySelector('.dd-collection-navigation__bar');
      const panel = this.querySelector('.dd-collection-navigation__panel');
      const details = this.querySelector('details');
      const button = this.querySelector('.dd-collection-navigation__button');
      this.setAttribute('data-ready', '');
      if (details && button) {
        const sync = () => button.setAttribute('aria-expanded', String(details.open));
        sync();
        details.addEventListener('toggle', sync, options);
        button.addEventListener('click', () => {
          details.open = !details.open;
          sync();
          if (details.open && panel.getBoundingClientRect().top < bar.getBoundingClientRect().bottom) {
            panel.scrollIntoView({ block: 'start', behavior: 'instant' });
          }
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target) && panel.contains(event.target)) {
            details.open = true;
            sync();
          }
        }, options);
      }
      const links = [...this.querySelectorAll('.dd-ux-size-nav a[href^="#"]')];
      const select = link => links.forEach(item => {
        if (item === link) item.setAttribute('aria-current', 'location');
        else item.removeAttribute('aria-current');
      });
      select(links.find(link => link.hash === location.hash) || links[0]);
      links.forEach(link => link.addEventListener('click', () => select(link), options));
      this.observer = new IntersectionObserver(entries => {
        const visible = entries.find(entry => entry.isIntersecting);
        if (visible) select(links.find(link => link.hash === '#' + visible.target.id));
      }, { rootMargin: '-15% 0px -65% 0px' });
      links.forEach(link => {
        const target = document.getElementById(link.hash.slice(1));
        if (target) this.observer.observe(target);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
